/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { AppBar, colors, IconButton, Toolbar, Button } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import BadgeX from "./BadgeX";
import { userStorage } from "src/common/Storage";
import { v4 as uuidv4 } from "uuid";
import { MoreVert } from "@material-ui/icons";
import { Divider, Menu, MenuItem } from "@mui/material";
import { useHistory } from 'react-router';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none",
    backgroundColor: "#fff",
  },
  flexGrow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: theme.spacing(1),
  },
  logoImage: {
    marginTop: theme.spacing(1),
    width: 100,
    [theme.breakpoints.down("md")]: {
      width: 100,
    },
    "&:hover": {
      cursor: "pointer",
    },
  },
  text: {
    color: "#1E77B8",
    fontSize: 24,
    paddingLeft: 12,
    marginLeft: 6,
    borderLeft: "2px solid",
    borderColor: "#E0E3E7",
  },
  textUserName: {
    color: "#72828A",
    fontSize: 24,
    paddingLeft: 12,
    marginLeft: 6,
    borderLeft: "2px solid",
    borderColor: "#E0E3E7",
  },
  moreButton: {
    marginLeft: "auto",
    color: colors.blueGrey[200],
  },
  details: {
    marginLeft: theme.spacing(2),
  },
  roleDetails: {
    marginLeft: theme.spacing(3),
    display: "block",
  },
  langButton: {
    minWidth: 40,
    backgroundColor: "#FFFEFE",
    marginLeft: 0,
    [theme.breakpoints.down("md")]: {
      minWidth: 30,
      height: 40,
    }
  },langButtonActive: {
    minWidth: 40,
    backgroundColor: "#00aeef3d",
    marginLeft: 0,
    [theme.breakpoints.down("md")]: {
      minWidth: 30,
      height: 40,
    }
  }
}));

function TopBar({ onToogleMenu, className, ...rest }) {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const userInfo = userStorage.getUser();
  const userProfile = userInfo?.userProfile || {};
  const vendorProfile = userInfo?.vendorProfile || {};
  const { i18n } = useTranslation();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuLogout = () => {
    setAnchorEl(null);
    localStorage.clear();
    window.location.href = `${process.env.REACT_APP_POTAL_WEBSITE}`;
  };
  const handleGotoHome = (event) => {
    history.push(userProfile.roleCode !== "VENDOR"
      ? "/EvaluationResult/InquiryAll"
      : "/vendorRegis");
  };
  const onChangeLanguage = (value) => {
    i18n.changeLanguage(value);
  };

  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <img onClick={handleGotoHome}
          className={classes.logoImage}
          alt="Logo"
          src="/images/pttlogo/logo_PTT_3.png"
        />
        <span className={classes.text}>
          <b>ESG</b> Self assessment
        </span>
        <IconButton
          className={classes.menuButton}
          color="default"
          onClick={onToogleMenu}
        >
          <MenuIcon />
        </IconButton>
        <div className={classes.flexGrow} />

        <BadgeX />

        <span className={classes.textUserName}>
          <b>
            {userProfile.roleCode !== "VENDOR"
              ? (userProfile.userName || "")
              : (vendorProfile.vendorCode || "")}
          </b>
          {" : "}
          {userProfile.roleCode !== "VENDOR"
            ? (userProfile.firstName || "") +
            " " +
            (userProfile.lastName || "")
            : (vendorProfile.vendorName || "")}
        </span>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={openMenu ? "long-menu" : undefined}
          aria-expanded={openMenu ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleMenuClick}
          className={classes.moreButton}
          size="small"
        >
          <MoreVert />
        </IconButton>

        <div>
          <Menu
            disableEnforceFocus
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                maxHeight: 48 * 4.5,
                width: "30ch",
              },
            }}
          >
            <span className={classes.details}>
              <b>Role</b>
            </span>
            {(userProfile.roleNames || "").split(",").map((role) => {
              return (
                <span key={uuidv4()} className={classes.roleDetails}>
                  {role}
                </span>
              );
            })}
            <Divider className={classes.divider} />
            <MenuItem key={uuidv4()} onClick={handleMenuLogout}>
              <b>กลับสู่หน้าหลัก (portal)</b>
            </MenuItem>
          </Menu>
        </div>
        <Button
          className={i18n.language === "th" ? classes.langButtonActive : classes.langButton}
          color="default"
          onClick={() => onChangeLanguage("th")}
        >
          TH
        </Button>
        <Button
          className={i18n.language === "en" ? classes.langButtonActive : classes.langButton}
          color="default"
          onClick={() => onChangeLanguage("en")}
        >
          EN
        </Button>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onToogleMenu: PropTypes.func,
};

export default TopBar;
